export default __webpack_public_path__ + "static/media/fond-arrondi-bleu.5f695064.webp";